import { ErrorView } from "components/ErrorView/ErrorView";
import { GuestPage } from "components/GuestPage/GuestPage";
import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

const AuthModule = React.lazy(() => import("./AuthModule"));
const AcceptInvitePage = React.lazy(() => import("./pages/AcceptInvitePage/AcceptInvitePage"));
const LoginPage = React.lazy(() => import("./pages/LoginPage/LoginPage"));
const ForgotPasswordPage = React.lazy(() => import("./pages/ForgotPasswordPage/ForgotPasswordPage"));
const ChangePasswordPage = React.lazy(() => import("./pages/ChangePasswordPage/ChangePasswordPage"));
const ResetPasswordPage = React.lazy(() => import("./pages/ResetPasswordPage/ResetPasswordPage"));
const SAMLLoginPage = React.lazy(() => import("./pages/SAMLLoginPage/SAMLLoginPage"));
const SAMLErrorPage = React.lazy(() => import("./pages/SAMLErrorPage/SAMLErrorPage"));
const ShareRegistrationPage = React.lazy(() => import("./pages/ShareRegistrationPage/ShareRegistrationPage"));

const DefaultPage: React.FC = () => {
  return <Navigate to="/auth/login" replace />;
};

export const AuthModuleRoutes: RouteObject = {
  path: "/auth",
  element: <GuestPage El={AuthModule} />,
  errorElement: <ErrorView />,
  children: [
    {
      path: "accept-invite",
      element: <GuestPage El={AcceptInvitePage} />,
    },
    {
      path: "change-password",
      element: <GuestPage El={ChangePasswordPage} />,
    },
    {
      path: "reset-password",
      element: <GuestPage El={ResetPasswordPage} />,
    },
    {
      path: "forgot-password",
      element: <GuestPage El={ForgotPasswordPage} />,
    },
    {
      path: "login",
      element: <GuestPage El={LoginPage} />,
    },
    {
      path: "sign-up",
      element: <GuestPage El={ShareRegistrationPage} />,
    },
    {
      path: "saml/login",
      element: <GuestPage El={SAMLLoginPage} />,
    },
    {
      path: "saml/error",
      element: <GuestPage El={SAMLErrorPage} />,
    },
    {
      path: "",
      Component: DefaultPage,
    },
    {
      path: "*",
      Component: DefaultPage,
    },
  ],
};
